<!--suppress ALL -->
<template>
	<v-select :items="roles" v-model="model" item-value="id" :label="$t('pages.roleSelect')"
		:disabled="lock">
		<template v-slot:item="{ item, index ,on,attrs}">
			<v-list-item v-on="on" v-bind="attrs" :style="{'background-color': getColor(item)}">
				{{item.text}}
				<span v-if="item.id < 5"> - CADnet</span>
			</v-list-item>
		</template>
	</v-select>
</template>

<script>

	import RoleManager, {types as roleTypes} from "dev/helpers/RoleManager";


	export default {
		name: "role-select",
		props: {value: {default: null}, lock: {type:Boolean,default: false},selectedGroup: {default: null}},
		data() {
			return {
				options:null
			};
		},
		computed: {
			model: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			},
			userRole() {
				return this.$store.state.AuthModule.user.role;
			},
			roles() {
				if (this.userRole >= roleTypes.BRANCH_MANAGER) {
					return RoleManager.branch();
				}
				if (this.selectedGroup === "clients")
					return RoleManager.clients();
				if (this.selectedGroup === "company")
					return RoleManager.company();
				else  //admin show all
					return RoleManager.roles;
			},
		},
		methods: {
			getColor(item) {
				if (item.id < 5) {
					return "#3d9ad6";
				} else if (item.id < 7) {
					return "rgb(62 191 34)";
				} else {
					return "rgb(107 195 88)";
				}
			}
		},
	};
</script>
